import { render, staticRenderFns } from "./BaseContactPopup.vue?vue&type=template&id=79039ca0"
import script from "./BaseContactPopup.vue?vue&type=script&lang=js"
export * from "./BaseContactPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79039ca0')) {
      api.createRecord('79039ca0', component.options)
    } else {
      api.reload('79039ca0', component.options)
    }
    module.hot.accept("./BaseContactPopup.vue?vue&type=template&id=79039ca0", function () {
      api.rerender('79039ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseContactPopup.vue"
export default component.exports